import Homepage from "@modules/homepage/Homepage"

export default Homepage
